export class CheckoutFastFlowSkipError extends Error {
  constructor(reason: string) {
    super(reason);
    this.name = "CheckoutFastFlowSkipError";
  }
}
